<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <!-- <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand> -->
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <!-- <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink> -->
        <CHeaderNavLink to="/home">
          Home
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CButton color="light" v-on:click="onTaskClicked">
            <CIcon name="cil-task"/>&nbsp;Tasks
            <CBadge v-if="tasksCount" color="danger" class="ml-2 position-static">{{tasksCount}}</CBadge>
          </CButton>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <div v-if="isAuthenticated == false">
        <button v-on:click="onLoginClicked" type="button" class="btn btn-primary rounded-pill">Login</button>
        <!-- <button v-on:click="onCheckClicked" type="button" class="btn btn-primary rounded-pill">Silent Login</button> -->
      </div>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
      <ol class="breadcrumb border-0 mb-0 mfs-auto">
        <li>
          <CLink
            class="card-header-action btn-minimize"
            v-on:click="onBackClicked"
          >
            <CIcon name="cil-arrow-circle-left"/>
          </CLink>
        </li>
      </ol>
    </CSubheader>
  </CHeader>
</template>

<script>
import auth from '@/auth'
import { axiosInstance } from '@/api'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data () {
    return {
      name: undefined
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated
    },
    isSuspended() {
      return this.$store.state.user.isSuspended
    },
    tasksCount() {
      return this.$store.state.tasksCount
    }
  },
  mounted() {
    // ### This page no route guard. So, it need to manual check user state before call MECAs Backend API. 
    // let i = 0
    // let interval = setInterval(() => {
    //   if (this.$store.state.user.isSuspended !== undefined || i > 10) {
    //     clearInterval( interval )
    //     if(this.$store.state.user.isSuspended === false) {
    //       this.getProjectTransfer()
    //     }
    //   }
    //   i++
    // }, 200)
  },
  methods: {
    onLoginClicked() {
      auth.login()
    },
    onCheckClicked() {
      auth.silentCheck()
    },
    // onTaskClicked() {
    //   // Prevent redirect to same page
    //   let path = '/projects'
    //   if ( window.location.pathname !== path ) {
    //     this.$router.push({ path: path })
    //   }
    // },
    onBackClicked() {
      this.$router.go(-1)
    },
  }
}
</script>
